export enum tooltipTypes {
  LUGGAGE = 'luggage',
  TEXT = 'text',
  PAYMENT_DETAIL= 'payment-detail'
}

export enum luggageTooltipParentTypes {
  ICON = 'parent-icon',
  COINT = 'parent-coint'
}

export enum textTooltipParents {
  HOTEL_PRICE_ICON = 'hotel-price-icon',
  FLIGHT_PRICE_ICON = 'flight-price-icon'
}
